import { Grid, Button, TextField, Typography } from '@mui/material';

import { useAuth } from '@lib/auth';
import { useRegenerateTeacherCodeMutation } from '@store/api/user.api.graphql';
import { useDispatch } from 'react-redux';
import { setCode } from '@store/slices/auth.slice';

const TeacherCodeSection = () => {
  const { user } = useAuth();
  const dispatch = useDispatch();

  const [regenerateTeacherCode, { isLoading: isLoadingRegenerateTeacherCode }] = useRegenerateTeacherCodeMutation();

  const handleRegenerateTeacherCode = async () => {
    regenerateTeacherCode()
      .then(res => {
        if ('error' in res) {
          console.error(res.error);
        } else {
          dispatch(setCode({ code: res.data.regenerateTeacherCode.code }));
        }
      })
      .catch(err => {
        console.error(err);
      });
  };

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item xs={12}>
        <Typography variant={'body1'}>Class Code</Typography>
      </Grid>
      <Grid item xs={9}>
        <TextField
          fullWidth
          variant={'filled'}
          color={'secondary'}
          size={'large'}
          disabled={false}
          InputProps={{
            readOnly: true,
          }}
          value={user?.code}
        />
      </Grid>
      <Grid item xs={3}>
        <Button
          variant="contained"
          color="tertiary"
          fullWidth
          size={'large'}
          disabled={isLoadingRegenerateTeacherCode}
          sx={{
            ':disabled': {
              color: 'white',
              background: theme => theme.palette.primary.main,
            },
          }}
          onClick={handleRegenerateTeacherCode}
        >
          Regenerate Class Code
        </Button>
      </Grid>
    </Grid>
  );
};

export default TeacherCodeSection;
